import { Army } from './army';
import { Battle } from './battle';
import { ImageDate } from './imageDate';
import { ImageIndividual } from './imageIndividual';
import { LU_Keyword } from './keyword';
import { QMManualLink } from './qmmanuallink';
import { State } from './state';
import { UnitLinking } from './unitLinking';
import { WeaponLinking } from './weaponLinking';

export class BatchEdit {
    imageModelUIDs: number[] = [];
    isBoundSet: boolean;
    boundSetName: string;
    isRelatedSet: boolean;
    relatedSetName: string;
    isOrdnanceReturn: boolean;
    location: string;
    locationStateID: number;
    locationState: State;
    addBattles: Battle[] = [];
    armyId: number;
    army: Army;
    notes: string;
    addKeywords: LU_Keyword[] = [];
    removeKeywords: LU_Keyword[] = [];
    addDates: ImageDate[] = [];
    addUnits: UnitLinking[] = [];
    addWeapons: WeaponLinking[] = [];
    addContractItems: QMManualLink[] = [];
    addIndividuals: ImageIndividual[] = [];
    checkedOut: boolean;

}
